export default __webpack_public_path__ + "static/media/musetaIcon.2856bd6d.svg";